import { render, staticRenderFns } from "./supervisionMatchDetails.vue?vue&type=template&id=30a90517&scoped=true&"
import script from "./supervisionMatchDetails.vue?vue&type=script&lang=js&"
export * from "./supervisionMatchDetails.vue?vue&type=script&lang=js&"
import style0 from "./supervisionMatchDetails.vue?vue&type=style&index=0&id=30a90517&lang=stylus&scoped=true&"
import style1 from "./supervisionMatchDetails.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a90517",
  null
  
)

export default component.exports